import { useEffect, useState } from 'react';
import { makeRESTApiRequest } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

const useCountyCityOptions = () => {
  const [countyCityData, setCountyCityData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCountyCityOptions = async () => {
      try {
        setLoading(true);
        const { response, error } = await makeRESTApiRequest({
          endpoint: ENDPOINTS.COUNTY_CITY_OPTIONS,
          method: 'GET',
          requestBody: null
        });

        if (error) {
          setError(error);
        } else {
          setCountyCityData(response || []);
        }
      } catch (err) {
        setError('Failed to fetch county-city options');
      } finally {
        setLoading(false);
      }
    };

    fetchCountyCityOptions();
  }, []);

  // Extract unique counties
  const counties = [...new Set(countyCityData.map(item => item.county))].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );

  // Extract cities (countyCities)
  const cities = countyCityData
    .map(item => item.countyCity)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

  // Create a map for county lookup by city
  const getCountyForCity = cityName => {
    const match = countyCityData.find(item => item.countyCity.toLowerCase() === cityName.toLowerCase());
    return match?.county || null;
  };

  return {
    countyCityData,
    counties,
    cities,
    getCountyForCity,
    loading,
    error
  };
};

export default useCountyCityOptions;
